import React from 'react';
import { startTour } from './GuidedTour';
import '../styles/tourButton.css';

/**
 * TourButton Component
 * 
 * A floating button that allows users to restart the guided tour at any time
 */
const TourButton = ({ tourId, label = "Help", position = "bottom-right" }) => {
  const handleClick = () => {
    startTour(tourId);
  };

  const positionStyles = {
    'bottom-right': { position: 'fixed', bottom: '100px', right: '24px', zIndex: 999 },
    'bottom-left': { position: 'fixed', bottom: '100px', left: '24px', zIndex: 999 },
    'top-right': { position: 'fixed', top: '80px', right: '24px', zIndex: 999 },
    'top-left': { position: 'fixed', top: '80px', left: '24px', zIndex: 999 },
  };

  return (
    <div
      style={positionStyles[position]}
      title="Start guided tour"
      data-tour-button={tourId}
    >
      <button className="tour-button" onClick={handleClick}>
        <span className="tour-button-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="5 3 19 12 5 21 5 3"></polygon>
          </svg>
        </span>
        <span className="tour-button-label">{label}</span>
      </button>
    </div>
  );
};

export default TourButton;

